import React from "react";
import { postOmise } from "../../api/async/payment/index";
import { Loader } from "../../components/Loader";
import { SummaryOrder } from "../../organisms/SummaryOrder";
import { getOrders } from "../../api/async/orders";
import { endEvent } from "../../utils";
import { notification } from "antd";

class OrderSummary extends React.Component {
  state = {
    order: {},
    bankAccountModalOpen: false
  };

  toggleBankAccountModal = () => {
    this.setState({ bankAccountModalOpen: !this.state.bankAccountModalOpen });
  };

  componentDidMount() {
    getOrders({ id: this.props.match.params.id }).then(res => {
      if (endEvent(res.data[0].event) && !res.data[0].is_paid) {
        this.props.history.push(`/my-order`);
        notification.warning({
          message: `ของสะสม ${res.data[0].event.title} ปิดการจ่ายเงินแล้ว`
        });
      }
      this.setState({ order: res.data[0] });
    });
  }

  onOmiseSuccess = (token, amount) => {
    postOmise({
      order: this.state.order.id,
      token,
      amount,
      type: "order"
    }).then(res => res.status === 200 && this.props.history.push(`/my-order`));
  };

  render() {
    return this.state.order !== {} ? (
      <SummaryOrder
        order={this.state.order}
        bankAccountModalOpen={this.state.bankAccountModalOpen}
        toggleBankAccountModal={this.toggleBankAccountModal}
        onPaypalSuccess={this.onPaypalSuccess}
        onOmiseSuccess={this.onOmiseSuccess}
      />
    ) : (
      <Loader />
    );
  }
}

export default OrderSummary;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/OrderSummary/index.js